import { Button } from "@mui/material";
import { ButtonStyles } from "../../styles/commonStyles";

const FormActionButton = ({
  startIcon,
  onClick,
  label,
  color = "primary",
  disabled,
  type,
  form,
  style,
  variant = "contained",
}) => {
  return (
    <Button
      startIcon={startIcon}
      variant={variant}
      sx={style || ButtonStyles}
      onClick={onClick}
      color={color}
      disabled={disabled}
      type={type}
      form={form}
    >
      {label}
    </Button>
  );
};

export default FormActionButton;
